
// This file is merge updated from amalgamd's js_operation_serializer program.
/*

./js_operation_serializer |
sed 's/void/future_extensions/g'|
sed 's/amalgam_protocol:://g'|
sed 's/14static_variantIJNS_12fixed_stringINSt3__14pairIyyEEEEEEE/string/g'|
sed 's/amalgam_future_extensions/future_extensions/g'|
sed 's/amalgam_protocol_//g' > tmp.coffee

*/
// coffee tmp.coffee # fix errors until you see: `ChainTypes is not defined`

/*

   remove these 7 lines from tmp.coffee:

static_variant [
    pow2
    equihash_pow
] = static_variant [
    pow2
    equihash_pow
]

*/

// npm i -g decaffeinate
// decaffeinate tmp.coffee

// Merge tmp.js - See "Generated code follows" below

import types from "./types"
import SerializerImpl from "./serializer"

const {
    uint16, uint32, int16, uint64,
    string, string_binary, bytes, bool, array,
    static_variant, map, set,
    public_key,
    time_point_sec,
    optional,
    asset,
} = types

const future_extensions = types.void
const hardfork_version_vote = types.void
const version = types.void

// Place-holder, their are dependencies on "operation" .. The final list of
// operations is not avialble until the very end of the generated code.
// See: operation.st_operations = ...
const operation = static_variant();
module.exports.operation = operation;

// For module.exports
const Serializer=function(operation_name, serilization_types_object){
    const s = new SerializerImpl(operation_name, serilization_types_object);
    return module.exports[operation_name] = s;
}

// Custom-types after Generated code

// ##  Generated code follows
// -------------------------------
/*
When updating generated code (fix closing notation)
Replace:  var operation = static_variant([
with:     operation.st_operations = [

Delete (these are custom types instead):
let public_key = new Serializer( 
    "public_key",
    {key_data: bytes(33)}
);

let asset = new Serializer( 
    "asset",
    {amount: int64,
    symbol: uint64}
);

Replace: authority.prototype.account_authority_map
With: map((string), (uint16))
*/
let signed_transaction = new Serializer( 
    "signed_transaction", {
    ref_block_num: uint16,
    ref_block_prefix: uint32,
    expiration: time_point_sec,
    operations: array(operation),
    extensions: set(future_extensions),
    signatures: array(bytes(65))
}
);

let signed_block = new Serializer( 
    "signed_block", {
    previous: bytes(20),
    timestamp: time_point_sec,
    witness: string,
    transaction_merkle_root: bytes(20),
    extensions: set(static_variant([
        future_extensions,    
        version,    
        hardfork_version_vote
    ])),
    witness_signature: bytes(65),
    transactions: array(signed_transaction)
}
);

let block_header = new Serializer( 
    "block_header", {
    previous: bytes(20),
    timestamp: time_point_sec,
    witness: string,
    transaction_merkle_root: bytes(20),
    extensions: set(static_variant([
        future_extensions,    
        version,    
        hardfork_version_vote
    ]))
}
);

let signed_block_header = new Serializer( 
    "signed_block_header", {
    previous: bytes(20),
    timestamp: time_point_sec,
    witness: string,
    transaction_merkle_root: bytes(20),
    extensions: set(static_variant([
        future_extensions,    
        version,    
        hardfork_version_vote
    ])),
    witness_signature: bytes(65)
}
);

let transfer = new Serializer( 
    "transfer", {
    from: string,
    to: string,
    amount: asset,
    memo: string
}
);

let transfer_to_vesting = new Serializer( 
    "transfer_to_vesting", {
    from: string,
    to: string,
    amount: asset,
    memo: string
}
);

let withdraw_vesting = new Serializer( 
    "withdraw_vesting", {
    account: string,
    vesting_shares: asset
}
);

let limit_order_create = new Serializer( 
    "limit_order_create", {
    owner: string,
    orderid: uint32,
    amount_to_sell: asset,
    min_to_receive: asset,
    fill_or_kill: bool,
    expiration: time_point_sec
}
);

let limit_order_cancel = new Serializer( 
    "limit_order_cancel", {
    owner: string,
    orderid: uint32
}
);

let price = new Serializer( 
    "price", {
    base: asset,
    quote: asset
}
);

let feed_publish = new Serializer( 
    "feed_publish", {
    publisher: string,
    exchange_rate: price
}
);

let convert = new Serializer( 
    "convert", {
    owner: string,
    requestid: uint32,
    amount: asset
}
);

var authority = new Serializer( 
    "authority", {
    weight_threshold: uint32,
    account_auths: map((string), (uint16)),
    key_auths: map((public_key), (uint16))
}
);

let account_create = new Serializer( 
    "account_create", {
    fee: asset,
    creator: string,
    new_account_name: string,
    owner: authority,
    active: authority,
    posting: authority,
    memo_key: public_key,
    json_metadata: string
}
);

let account_update = new Serializer( 
    "account_update", {
    account: string,
    owner: optional(authority),
    active: optional(authority),
    posting: optional(authority),
    memo_key: public_key,
    json_metadata: string
}
);

let chain_properties = new Serializer( 
    "chain_properties", {
    account_creation_fee: asset,
    maximum_block_size: uint32,
    abd_interest_rate: uint16
}
);

let witness_update = new Serializer( 
    "witness_update", {
    owner: string,
    url: string,
    block_signing_key: public_key,
    props: chain_properties,
    fee: asset
}
);

let account_witness_vote = new Serializer( 
    "account_witness_vote", {
    account: string,
    witness: string,
    approve: bool
}
);

let account_witness_proxy = new Serializer( 
    "account_witness_proxy", {
    account: string,
    proxy: string
}
);

let custom = new Serializer( 
    "custom", {
    required_auths: set(string),
    id: uint16,
    data: bytes()
}
);

let custom_json = new Serializer( 
    "custom_json", {
    required_auths: set(string),
    required_posting_auths: set(string),
    id: string,
    json: string
}
);

let set_withdraw_vesting_route = new Serializer( 
    "set_withdraw_vesting_route", {
    from_account: string,
    to_account: string,
    percent: uint16,
    auto_vest: bool
}
);

let limit_order_create2 = new Serializer( 
    "limit_order_create2", {
    owner: string,
    orderid: uint32,
    amount_to_sell: asset,
    exchange_rate: price,
    fill_or_kill: bool,
    expiration: time_point_sec
}
);

let request_account_recovery = new Serializer( 
    "request_account_recovery", {
    recovery_account: string,
    account_to_recover: string,
    new_owner_authority: authority,
    extensions: set(future_extensions)
}
);

let recover_account = new Serializer(
    "recover_account", {
    account_to_recover: string,
    new_owner_authority: authority,
    recent_owner_authority: authority,
    extensions: set(future_extensions)
}
);

let change_recovery_account = new Serializer( 
    "change_recovery_account", {
    account_to_recover: string,
    new_recovery_account: string,
    extensions: set(future_extensions)
}
);

let escrow_transfer = new Serializer( 
    "escrow_transfer", {
    from: string,
    to: string,
    abd_amount: asset,
    amalgam_amount: asset,
    escrow_id: uint32,
    agent: string,
    fee: asset,
    json_meta: string,
    ratification_deadline: time_point_sec,
    escrow_expiration: time_point_sec
}
);

let escrow_dispute = new Serializer( 
    "escrow_dispute", {
    from: string,
    to: string,
    agent: string,
    who: string,
    escrow_id: uint32
}
);

let escrow_release = new Serializer( 
    "escrow_release", {
    from: string,
    to: string,
    agent: string,
    who: string,
    receiver: string,
    escrow_id: uint32,
    abd_amount: asset,
    amalgam_amount: asset
}
);

let escrow_approve = new Serializer( 
    "escrow_approve", {
    from: string,
    to: string,
    agent: string,
    who: string,
    escrow_id: uint32,
    approve: bool
}
);

let transfer_to_savings = new Serializer( 
    "transfer_to_savings", {
    from: string,
    to: string,
    amount: asset,
    memo: string
}
);

let transfer_from_savings = new Serializer( 
    "transfer_from_savings", {
    from: string,
    request_id: uint32,
    to: string,
    amount: asset,
    memo: string
}
);

let cancel_transfer_from_savings = new Serializer( 
    "cancel_transfer_from_savings", {
    from: string,
    request_id: uint32
}
);

let custom_binary = new Serializer( 
    "custom_binary", {
    required_owner_auths: set(string),
    required_active_auths: set(string),
    required_posting_auths: set(string),
    required_auths: array(authority),
    id: string,
    data: bytes()
}
);

let decline_voting_rights = new Serializer( 
    "decline_voting_rights", {
    account: string,
    decline: bool
}
);

let delegate_vesting_shares = new Serializer( 
    "delegate_vesting_shares", {
    delegator: string,
    delegatee: string,
    vesting_shares: asset
}
);

let witness_set_properties = new Serializer( 
    "witness_set_properties", {
    owner: string,
    props: map((string), (bytes())),
    extensions: set(future_extensions),
}
);

let tbd1 = new Serializer( 
    "tbd1", {
    from: string
}
);

let tbd2 = new Serializer( 
    "tbd2", {
    from: string
}
);

let tbd3 = new Serializer( 
    "tbd3", {
    from: string
}
);

let tbd4 = new Serializer( 
    "tbd4", {
    from: string
}
);

let tbd5 = new Serializer( 
    "tbd5", {
    from: string
}
);

let tbd6 = new Serializer( 
    "tbd6", {
    from: string
}
);

let tbd7 = new Serializer( 
    "tbd7", {
    from: string
}
);

let tbd8 = new Serializer( 
    "tbd8", {
    from: string
}
);

let tbd9 = new Serializer( 
    "tbd9", {
    from: string
}
);

let tbd10 = new Serializer( 
    "tbd10", {
    from: string
}
);

let fill_convert_request = new Serializer( 
    "fill_convert_request", {
    owner: string,
    requestid: uint32,
    amount_in: asset,
    amount_out: asset
}
);

let interest = new Serializer( 
    "interest", {
    owner: string,
    interest: asset
}
);

let fill_vesting_withdraw = new Serializer( 
    "fill_vesting_withdraw", {
    from_account: string,
    to_account: string,
    withdrawn: asset,
    deposited: asset
}
);

let fill_order = new Serializer( 
    "fill_order", {
    current_owner: string,
    current_orderid: uint32,
    current_pays: asset,
    open_owner: string,
    open_orderid: uint32,
    open_pays: asset
}
);

let fill_transfer_from_savings = new Serializer( 
    "fill_transfer_from_savings", {
    from: string,
    to: string,
    amount: asset,
    request_id: uint32,
    memo: string
}
);

let hardfork = new Serializer( 
    "hardfork",
    {hardfork_id: uint32}
);

let return_vesting_delegation = new Serializer( 
    "return_vesting_delegation", {
    account: string,
    vesting_shares: asset
}
);

let producer_reward = new Serializer( 
    "producer_reward", {
    producer: string,
    vesting_shares: asset
}
);

let clear_null_account_balance = new Serializer( 
    "clear_null_account_balance", {
    total_cleared: array(asset)
}
);

operation.st_operations = [
    transfer,    
    transfer_to_vesting,    
    withdraw_vesting,    
    limit_order_create,    
    limit_order_cancel,    
    feed_publish,    
    convert,    
    account_create,    
    account_update,    
    witness_update,    
    account_witness_vote,    
    account_witness_proxy,    
    custom,    
    custom_json,    
    set_withdraw_vesting_route,    
    limit_order_create2,    
    request_account_recovery,    
    recover_account,    
    change_recovery_account,    
    escrow_transfer,    
    escrow_dispute,    
    escrow_release,    
    escrow_approve,    
    transfer_to_savings,    
    transfer_from_savings,    
    cancel_transfer_from_savings,    
    custom_binary,    
    decline_voting_rights,    
    delegate_vesting_shares,    
    witness_set_properties,    
    tbd1,    
    tbd2,    
    tbd3,    
    tbd4,    
    tbd5,    
    tbd6,    
    tbd7,    
    tbd8,    
    tbd9,    
    tbd10,    
    fill_convert_request,    
    interest,    
    fill_vesting_withdraw,    
    fill_order,    
    fill_transfer_from_savings,    
    hardfork,    
    return_vesting_delegation,    
    producer_reward,    
    clear_null_account_balance    
];

let transaction = new Serializer( 
    "transaction", {
    ref_block_num: uint16,
    ref_block_prefix: uint32,
    expiration: time_point_sec,
    operations: array(operation),
    extensions: set(future_extensions)
}
);

//# -------------------------------
//#  Generated code end  S T O P
//# -------------------------------

// Custom Types (do not over-write)

const encrypted_memo = new Serializer(
    "encrypted_memo",
    {from: public_key,
    to: public_key,
    nonce: uint64,
    check: uint32,
    encrypted: string_binary}
);
/*

// Make sure all tests pass

npm test

*/



// WEBPACK FOOTER //
// ./src/auth/serializer/src/operations.js